import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import LogoutIcon from "@mui/icons-material/Logout";
import { FC } from "react";
import { auth } from "../../firebase";
import CustomTooltip from "../helpers/CustomTooltip";
import { useAppSelector } from "../../redux/store";
import { myInfoStateSelector } from "../../redux/slices/auth/my-info.slice";
import { Email } from "@mui/icons-material";
import { Avatar, Box, CircularProgress, IconButton } from "@mui/material";

interface AccountMenuProps {}

const AccountMenu: FC<AccountMenuProps> = () => {
  const { myInfo, loading } = useAppSelector(myInfoStateSelector);
  return (
    <>
      <CustomTooltip
        triggerElement={(onClick) => (
          <IconButton color="inherit" onClick={onClick}>
            {loading && (
              <CircularProgress
                sx={{
                  position: "absolute",
                }}
                size={32}
                color="inherit"
              />
            )}
            <Avatar
              src={myInfo?.photoURL ?? ""}
              imgProps={{ referrerPolicy: "no-referrer" }}
              sx={{
                width: 26,
                height: 26,
              }}
            />
          </IconButton>
        )}
      >
        {myInfo && (
          <MenuItem disabled>
            <ListItemIcon>
              <Email fontSize="small" />
            </ListItemIcon>
            <Box component="span" dir="ltr">
              {myInfo.email}
            </Box>
          </MenuItem>
        )}
        <MenuItem
          sx={{
            width: 200,
          }}
          onClick={() => auth.signOut()}
        >
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          יציאה
        </MenuItem>
      </CustomTooltip>
    </>
  );
};

export default AccountMenu;
